import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

export default function MailboxDetailLoader() {
  return (
    <div className="w-full">
      <div className="space-y-5">
        {/* Header */}
        <div className="flex flex-col sm:flex-row justify-between items-center gap-2">
          <Skeleton className="h-8 w-40" />
          <div className="flex items-center gap-2">
            <Skeleton className="h-9 w-48" />
          </div>
        </div>

        {/* Top Section */}
        <div className="flex flex-col xl:flex-row xl:items-center justify-between gap-4 pb-6 border-b">
          <div className="flex flex-col sm:flex-row items-center gap-2">
            <Skeleton className="h-8 w-56" />
            <Skeleton className="h-8 w-40" />
          </div>
          <div className="flex flex-wrap items-center gap-2 justify-between xl:justify-end">
            <Skeleton className="h-9 w-56" />
            <div className="flex items-center gap-2">
              <Skeleton className="h-10 w-10 rounded-full" />
              <Skeleton className="h-10 w-10 rounded-full" />
            </div>
          </div>
        </div>

        {/* Settings Grid */}
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {[...Array(3)].map((_, i) => (
            <Card key={i} className="p-4 space-y-2">
              <div className="flex items-center gap-2">
                <Skeleton className="size-8 rounded-lg" />
                <Skeleton className="h-5 w-24" />
              </div>
              <Skeleton className="h-7 w-full" />
            </Card>
          ))}
        </div>

        {/* Second row of cards */}
        <div className="grid gap-4 md:grid-cols-2 mt-4">
          {[...Array(2)].map((_, i) => (
            <Card key={i} className="p-4 space-y-2">
              <div className="flex items-center justify-between">
                <div className="space-y-2">
                  <Skeleton className="h-5 w-24" />
                  <Skeleton className="h-10 w-24" />
                </div>

                <Skeleton className="size-10" />
              </div>
              <hr className="my-2" />
              <Skeleton className="h-5 w-24" />
            </Card>
          ))}
        </div>

        {/* Email Placement */}
        <div className="space-y-2 mt-4">
          <Skeleton className="h-7 w-48" />
          <div className="bg-background border rounded-lg p-4 space-y-4">
            {[...Array(4)].map((_, i) => (
              <div key={i} className="space-y-2">
                <div className="flex justify-between items-center">
                  <Skeleton className="h-5 w-24" />
                  <Skeleton className="h-5 w-10" />
                </div>
                <Skeleton className="h-2 w-full rounded-full" />
                <div className="text-right">
                  <Skeleton className="h-4 w-16 ml-auto" />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Daily Statistics Table */}
        <div className="mt-4 md:mt-8">
          <div className="justify-between w-full items-center flex mb-2">
            <Skeleton className="h-7 max-w-48 w-full" />
            <Skeleton className="h-7 max-w-24 w-full" />
          </div>
          {/* Table skeleton */}
          <div className="space-y-2">
            <Card className="p-4 space-y-2">
              {[...Array(6)].map((_, i) => (
                <Skeleton key={i} className="h-8 w-full" />
              ))}
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
}
